import React from "react";
import Hero from "./hero/Hero";

const Header = () => {
  return (
    <div>
      <Hero />
    </div>
  );
};

export default Header;
